import React from 'react';

const AboutUs = () => {
  return (
   
   
   
   <div >
    
        <div className='row justify-content-center text-center mb-5'>
          <div className='col-md-4'>
            <h2 className='text-4xl section-heading'>  <br />Who we are ?</h2>
          </div>
            <p class="blockquote">  <br />
              My Library is a digital library project powered by SHENGEN pvt Ltd.  <br />My Library is a 
            digital platform gives you access to millions of  <br />ebooks, audiobooks,
            magazines and e newspapers all in one place.  <br />
            My library include sinhala digital library which allow users to access old and new books.</p>
        </div>

        <br />
        <br />
        <br />

        <div className='row justify-content-center text-center mb-5'>
          <div className='col-md-4'>
            <h2 className='text-4xl section-heading'>Our Vision</h2>
          </div>
          <p class="blockquote" >  <br />   Our vision is an educated, <br />
  
            connected community of readers, learners, doers, and dreamers.</p>
        </div>
        <br />
        <br />
        <br />
        <div className='row justify-content-center text-center mb-5'>
          <div className='col-md-4'>
            <h2 className='text-4xl section-heading'>Our Mission</h2>
          </div>
       
     
            <p class="blockquote">  <br />  Our vision is an educated,
            <br />
            by educating, inspiring and connecting people and
            build <br />the largest and most accessible library connecting with their
            audience.</p>
            
        </div>
    </div> 
  );
};

export default AboutUs;

